import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle responses and errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const auth = {
  login: (username, password) => api.post('/api/auth/login', { username, password }),
  getMe: () => api.get('/api/auth/me'),
  changePassword: (currentPassword, newPassword) => 
    api.post('/api/auth/change-password', { currentPassword, newPassword })
};

// Positions
export const positions = {
  getAll: (params) => api.get('/api/positions', { params }),
  getOne: (id) => api.get(`/api/positions/${id}`),
  create: (data) => api.post('/api/positions', data),
  update: (id, data) => api.put(`/api/positions/${id}`, data),
  delete: (id, moveToReleased) => api.delete(`/api/positions/${id}`, { params: { moveToReleased } }),
  checkStatus: (id) => api.post(`/api/positions/${id}/check-status`)
};

// Applicants
export const applicants = {
  getAll: (params) => api.get('/api/applicants', { params }),
  getFilterOptions: (status) => api.get('/api/applicants/filter-options', { params: { status } }),
  getOne: (id) => api.get(`/api/applicants/${id}`),
  apply: (data) => api.post('/api/applicants/apply', data),
  update: (id, data) => api.put(`/api/applicants/${id}`, data),
  move: (id, to_status) => api.post(`/api/applicants/${id}/move`, { to_status }),
  download: (id) => api.get(`/api/applicants/${id}/download`, { responseType: 'blob' }),
  delete: (id) => api.delete(`/api/applicants/${id}`),
  getNotes: (id) => api.get(`/api/applicants/${id}/notes`),
  addNote: (id, body) => api.post(`/api/applicants/${id}/notes`, { body }),
  getResumeMeta: (id) => api.get(`/api/applicants/${id}/resume/meta`),
  downloadResume: (id) => api.get(`/api/applicants/${id}/resume`, { responseType: 'blob' })
};

// Users
export const users = {
  getAll: () => api.get('/api/users'),
  getOne: (id) => api.get(`/api/users/${id}`),
  create: (data) => api.post('/api/users', data),
  update: (id, data) => api.put(`/api/users/${id}`, data),
  resetPassword: (id) => api.post(`/api/users/${id}/reset-password`),
  delete: (id) => api.delete(`/api/users/${id}`)
};

// Metrics
export const metrics = {
  getAll: () => api.get('/api/metrics')
};

export default api;
